var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6445 0.0078125H4.35547C2.87891 0.0078125 1.66797 1.21875 1.66797 2.69531V17.3047C1.66797 18.7813 2.87891 19.9922 4.35547 19.9922H15.6484C17.125 19.9922 18.3359 18.7813 18.3359 17.3047V2.69531C18.332 1.21875 17.125 0.0078125 15.6445 0.0078125ZM16.5039 15.8086C16.5039 16.9727 15.5508 17.9219 14.3906 17.9219H5.50781C4.34375 17.9219 3.39453 16.9688 3.39453 15.8086V4.31641C3.39453 3.15234 4.34766 2.20313 5.50781 2.20313H14.3906C15.5547 2.20313 16.5039 3.15625 16.5039 4.31641V15.8086Z",
    fill: "#888888",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1602 9.91016V10.1406C15.1602 10.582 14.8008 10.9414 14.3594 10.9414H8.25781C7.81641 10.9414 7.45703 10.582 7.45703 10.1406V9.91016C7.45703 9.46875 7.81641 9.10938 8.25781 9.10938H14.3594C14.8008 9.10938 15.1602 9.46875 15.1602 9.91016Z",
    fill: "#888888",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1602 13.4023V13.6328C15.1602 14.0742 14.8008 14.4336 14.3594 14.4336H8.25781C7.81641 14.4336 7.45703 14.0742 7.45703 13.6328V13.4023C7.45703 12.9609 7.81641 12.6016 8.25781 12.6016H14.3594C14.8008 12.6055 15.1602 12.9648 15.1602 13.4023Z",
    fill: "#888888",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1602 6.34766V6.57812C15.1602 7.01953 14.8008 7.37891 14.3594 7.37891H8.25781C7.81641 7.37891 7.45703 7.01953 7.45703 6.57812V6.34766C7.45703 5.90625 7.81641 5.54688 8.25781 5.54688H14.3594C14.8008 5.54688 15.1602 5.90625 15.1602 6.34766Z",
    fill: "#888888",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77344 7.40625C6.28689 7.40625 6.70313 6.99001 6.70313 6.47656C6.70313 5.96311 6.28689 5.54688 5.77344 5.54688C5.25999 5.54688 4.84375 5.96311 4.84375 6.47656C4.84375 6.99001 5.25999 7.40625 5.77344 7.40625Z",
    fill: "#888888",
    fillOpacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77344 10.8359C6.28689 10.8359 6.70313 10.4197 6.70313 9.90625C6.70313 9.3928 6.28689 8.97656 5.77344 8.97656C5.25999 8.97656 4.84375 9.3928 4.84375 9.90625C4.84375 10.4197 5.25999 10.8359 5.77344 10.8359Z",
    fill: "#888888",
    fillOpacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77344 14.4492C6.28689 14.4492 6.70313 14.033 6.70313 13.5195C6.70313 13.0061 6.28689 12.5898 5.77344 12.5898C5.25999 12.5898 4.84375 13.0061 4.84375 13.5195C4.84375 14.033 5.25999 14.4492 5.77344 14.4492Z",
    fill: "#888888",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.b6efad7d5486eeabe6fc1b72a4ed079d.svg";
export { ForwardRef as ReactComponent };